import BaseService from "./base.service";
import Big from "big.js";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";
import Moment from "moment";

@Singleton
export default class StockOperationsService extends BaseService {
  async fetch(companyUuid, { order, pagination, filters, transforms }) {
    const url = `/v1/companies/${companyUuid}/stock_operations`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      order,
      pagination,
      filters,
      transforms
    });

    return await this.get(resourceRoute);
  }

  async graphFetch({ order, pagination, filters, transforms, group }) {
    const url = `/v1/stock_operations`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      order,
      pagination,
      filters,
      group
    });

    return await this.get(resourceRoute);
  }

  async create(companyUuid, params) {
    return await this.post(
      `/v1/companies/${companyUuid}/stock_operations`,
      params
    );
  }

  async graph(productUuid, dateFrom, dateTo, interval) {
    const from = Moment(dateFrom).startOf(interval);
    const to = Moment(dateTo).endOf(interval);
    const steps = Math.ceil(to.diff(from, interval, true));

    const results$ = [];

    for (let i = 0; i < steps; i++) {
      const periodStart = Moment(from);
      const periodEnd = Moment(from).add(1, interval);

      const fetchResult = this.graphFetch({
        filters: [
          {
            connector: "AND",
            field: "sellable_uuid",
            operation: "EQ",
            value: productUuid
          },
          {
            connector: "AND",
            field: "created_at",
            operation: "GTE",
            value: periodStart.toISOString()
          },
          {
            connector: "AND",
            field: "created_at",
            operation: "LT",
            value: periodEnd.toISOString()
          },
          {
            connector: "AND",
            field: "cost_value",
            operation: "GTE",
            value: "0"
          },
          {
            connector: "AND",
            field: "activity",
            operation: "EQ",
            value: "manual_input"
          }
        ]
      }).then(result => {
        if (!result.success) {
          return { error: result };
        }

        if (result.data[result.data.length - 1] === undefined) {
          return { from: periodStart, to: periodEnd, value: Big(0) };
        } else {
          return {
            from: periodStart,
            to: periodEnd,
            value: Big(result.data[result.data.length - 1].cost_value)
          };
        }
      });

      results$.push(fetchResult);
      from.add(1, interval);
    }

    const results = await Promise.all(results$);

    for (const result of results) {
      if (result.error) {
        return result.error;
      }
    }
    return { success: true, data: results };
  }
}



// WEBPACK FOOTER //
// ./src/core/service/stock-operations.service.js